const initialstate = {
    data: [],

}

const OrgapplicationsReducers = (state = initialstate, action: any) => {
    switch (action.type) {
        case 'fetch_data_success':
            return { ...state, data: action.payload };
        default:
            return state;
    }
};
export default OrgapplicationsReducers;